<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Bulk Assign</p>
    </header>
    <section class="modal-card-body">
      <b-field label="Username">
        <b-select v-model="selected" expanded>
          <option v-for="user in users" :value="user" :key="user">{{
            user
          }}</option>
        </b-select>
      </b-field>
      <b-field :label="`How many out of ${outof} ?`">
        <b-numberinput v-model="number" :controls="false"></b-numberinput>
      </b-field>
    </section>
    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">
        Cancel
      </button>
      <button class="button is-info" type="button" @click="onClickAssign">
        Assign
      </button>
      <div class="spacer"></div>
      <button class="button is-warning" type="button">
        Unassign From All
      </button>
    </footer>
  </div>
</template>

<script>
import { ref, onMounted } from "@vue/composition-api";
import useUsers from "@/composables/useUsers";
import useProjectFloorplans from "@/composables/useProjectFloorplans";
import useSnackbar from "@/composables/useSnackbar";
import ui from "@/store/modules/ui";

export default {
  props: {
    reloadTable: Function,
    version: String
  },
  setup(props, { parent }) {
    // Composables
    const { users } = useUsers();
    const { fetch: fetchFloorplans } = useProjectFloorplans(
      ui.selectedProjectId,
      {
        initialize: false
      }
    );
    const { open: openSnack } = useSnackbar();
    // Ui States
    const selected = ref("");
    const number = ref(0);
    const outof = ref(0);
    // Event Callbacks
    //     Assign Button
    const onClickAssign = async () => {
      // Validation
      if (number.value > outof) {
        openSnack("Given number exceeds the limit.");
      }
      if (number.value < 1) {
        openSnack("Please give me an positive integer.");
      }
      if (!selected.value.trim()) {
        openSnack("Please chose an user.");
      }
      try {
        // Fetch requested number of floorplans.
        const res = await fetchFloorplans(1, {
          perPage: number.value,
          filters: {
            assignedUser: "",
            name: `.*_${props.version}`
          }
        });
        if (!res) {
          throw new Error("Accessing the server failed.");
        }
        // Assign them all to the given user.
        const floorplanNames = res.docs.map(o => o.name);
        ui.assignImagesToUsers({
          userId: selected.value,
          imageIds: floorplanNames
        });
      } catch (err) {
        openSnack("Accessing the server failed.");
      }
      try {
        await props.reloadTable();
      } catch (err) {
        openSnack(err.message);
      }
      parent.close();
    };
    // Initialization
    onMounted(async () => {
      const res = await fetchFloorplans(1, {
        perPage: 1,
        filters: {
          assignedUser: "",
          name: `.*_${props.version}`
        }
      });
      outof.value = res.totalDocs;
    });
    return {
      // Composables
      users,
      // Ui States
      selected,
      number,
      outof,
      // Event Callbacks
      onClickAssign
    };
  }
};
</script>

<style lang="scss" scoped>
.modal-card-foot {
  display: flex;
  flex-direction: row;
}
.spacer {
  flex: 1 0 0;
}
</style>
